import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Marker, useMap } from "react-map-gl/mapbox";
import { useLocation } from "@/location/hooks/useLocation";
import { DEFAULT_ZOOM } from "../../../constants";
import { useMapContext } from "@/domains/map";
import { useTokens } from "@gemini/core";
export const PinMarker = () => {
    const { current: map } = useMap();
    const location = useLocation();
    const geometry = location === null || location === void 0 ? void 0 : location.geometry;
    const { isStyleLoaded } = useMapContext();
    const { "color.surface.brand.primary.default": markerColor } = useTokens();
    useEffect(() => {
        map === null || map === void 0 ? void 0 : map.setZoom(DEFAULT_ZOOM);
    }, [map]);
    if (!isStyleLoaded || (geometry === null || geometry === void 0 ? void 0 : geometry.type) !== "Point") {
        return null;
    }
    const longitude = geometry.coordinates[0];
    const latitude = geometry.coordinates[1];
    return (_jsx(Marker, { longitude: longitude, latitude: latitude, anchor: "bottom", color: markerColor }));
};
